const mutations = {
  getMainHeader: (state, main_header) => {
    // Merge with existing state to preserve structure
    state.main_header = {
      ...state.main_header,
      ...main_header
    };
  },
  postMainHeader: (state, new_main_header) => {
    // Merge with existing state to preserve structure
    state.main_header = {
      ...state.main_header,
      ...new_main_header
    };
  },
};

export default mutations;
